export enum ComfyAgents {
  TRAMO = 'TraMo',
  PROVISIONING = 'Online Provisioning',
  RSU = 'RSU',
}
